import { normalizeRoute } from "@portal/utilities/normalizer";
import * as Sentry from "@sentry/react";
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";
import { root } from "../utilities/frontEndConfig.js";
import { ContentWrapper } from "./ContentWrapper.js";

const HomePage = lazy(() => import(`../home/HomePage.js`).then((module) => ({ default: module.HomePage })));
const CommercialPage = lazy(() => import(`../commercial/CommercialPage.js`).then((module) => ({ default: module.CommercialPage })));
const OperatorLayout = lazy(() => import(`../operator/OperatorLayout.js`).then((module) => ({ default: module.OperatorLayout })));
const OperatorList = lazy(() => import(`../operator/OperatorList.js`).then((module) => ({ default: module.OperatorList })));
const PartnerLayout = lazy(() => import(`../partner/PartnerLayout.js`).then((module) => ({ default: module.PartnerLayout })));
const PartnerList = lazy(() => import(`../partner/PartnerList.js`).then((module) => ({ default: module.PartnerList })));
const PartnerDetail = lazy(() => import(`../partner/PartnerDetail.js`).then((module) => ({ default: module.PartnerDetail })));
const PartnerRoster = lazy(() => import(`../partner/PartnerRoster.js`).then((module) => ({ default: module.PartnerRoster })));
const PartnerApiKeys = lazy(() => import(`../partner/PartnerApiKeys.js`).then((module) => ({ default: module.PartnerApiKeys })));
const PartnerAudit = lazy(() => import(`../partner/PartnerAudit.js`).then((module) => ({ default: module.PartnerAudit })));
const PartnerTuples = lazy(() => import(`../partner/PartnerTuples.js`).then((module) => ({ default: module.PartnerTuples })));
const PartnerModel = lazy(() => import(`../partner/PartnerModel.js`).then((module) => ({ default: module.PartnerModel })));
const ResourceList = lazy(() => import(`../resource/ResourceList.js`).then((module) => ({ default: module.ResourceList })));
const SentryRoutes = Sentry.wrapReactRouterRouting(Routes);

/**
 * Declares the navigation structure for the Zeus frontend.
 */
export const AppRoutes = () => {
  return (
    <ContentWrapper>
      <Suspense fallback={<span className="u-text--muted">Loading…</span>}>
        <SentryRoutes>
          <Route path={normalizeRoute(`${root}`)} element={<HomePage />} />
          <Route path={normalizeRoute(`${root}/commercial`)} element={<CommercialPage />} />
          <Route path={normalizeRoute(`${root}/operate`)} element={<OperatorLayout />}>
            <Route index element={<Navigate to="operator-list" replace />} />
            <Route path="operator-list" element={<OperatorList />} />
          </Route>
          <Route path={normalizeRoute(`${root}/partner`)} element={<PartnerLayout />}>
            <Route index element={<PartnerList />} />
            <Route path="new" element={<PartnerDetail />} />
            <Route path=":partner" element={<PartnerDetail />} />
            <Route path=":partner/roster" element={<PartnerRoster />} />
            <Route path=":partner/api-keys" element={<PartnerApiKeys />} />
            <Route path=":partner/audit" element={<PartnerAudit />} />
            <Route path=":partner/tuples" element={<PartnerTuples />} />
            <Route path=":partner/model" element={<PartnerModel />} />
            <Route path=":partner/resource" element={<ResourceList />}>
              <Route path="new" element={<ResourceList />} />
              <Route path=":resourceId/edit" element={<ResourceList />} />
            </Route>
          </Route>
          <Route path="*" element={<HomePage />} />
        </SentryRoutes>
      </Suspense>
    </ContentWrapper>
  );
};
